import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { OnlinePayementInfo } from '@app/core/business/invoice/online-payement-info';

@Component({
  selector: 'app-bill-payment',
  templateUrl: './bill-payment.component.html',
  styleUrls: ['./bill-payment.component.scss']
})
export class BillPaymentComponent implements OnInit {

  @Input()
  public onlinePayementInfo: OnlinePayementInfo;

  @Input()
  public inInvoice: boolean;
  
  constructor() { }

  ngOnInit() {
  }

  onSubmit(form: any, e: any): void {
    e.target.submit();
  }
}
